module.exports = __webpack_public_path__ + "static/media/icon_reset.8a9b93d7.svg";